// extracted by mini-css-extract-plugin
export default {"root":"MyVYz_","SeparateLinesMenuButtonNSkin":"fdaMIZ","separateLinesMenuButtonNSkin":"fdaMIZ","linkElement":"E1VNo6","gapper":"Hq4gwT","borderWrapper":"zfoCnx","label":"DlV2Vc"};